export default __webpack_public_path__ + "static/media/screenShots_web-2.fe98c624.jpg";